import axios from "axios";
import AuthAPI from "./auth";

export default class BusinessAPI {
  /**
   * @type {axios}
   */
  #client;

  /**
   * @type {AuthAPI}
   */
  #auth;
  constructor(client, authApi) {
    this.#client = client;
    this.#auth = authApi;
  }

  async getMyBusiness() {
    try {
      const result = await this.#client.get("/business/@me");
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async getMybotChats() {
    try {
      const result = await this.#client.get(`/business/@me/chats`);
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async getAllBots() {
    try {
      const result = await this.#client.get("/business/@bots");
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async getUsername(username) {
    try {
      const result = await this.#client.get(`/business/@${username}`);
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async getMessages(roomId) {
    try {
      const result = await this.#client.get(
        `/business/chats/${roomId}/messages`
      );
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async submitMyBot(logo, website, prompt, files) {
    try {
      const result = await this.#client.post(`/business/@me`, {
        logo,
        website,
        prompt,
        files,
      });
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async updateMyBot(logo, website, prompt, files) {
    try {
      const result = await this.#client.patch(`/business/@me`, {
        logo,
        website,
        prompt,
        files,
      });
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async createBotChatroom(username) {
    try {
      const result = await this.#client.post(`/business/@${username}`);
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async sendMessage(roomId, message) {
    try {
      const result = await this.#client.put(
        `/business/chats/${roomId}/chat`,
        {
          message,
        },
        {
          headers: {
            "Access-Control-Request-Method": "PUT",
          },
        }
      );
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }

  async updateStatus(username, status) {
    try {
      const result = await this.#client.patch(`/business/@${username}`, {
        status,
      });
      if (result.data && result.data.ok) return result.data.data;
      else if (result.data && !result.data.ok) return result.data.error;
    } catch (error) {
      return false;
    }
  }
}
